<template>
  <div class="stock_add_page">
    <b-breadcrumb :items="breadCrumbs" />
    <div class="row">
      <div class="col-6 offset-3">
        <div style="padding:15px;width:100%;">
          <div class="form-group">
            <label for="model">Model *</label>
            <input
              :class="{
                'is-invalid': $v.form.model.$invalid && submit,
                'is-valid': !$v.form.model.$invalid && submit
              }"
              type="text"
              ref="model"
              v-model="form.model"
              @change="trimExpiryDate"
              @keyup="trimExpiryDate"
              class="form-control"
              id="model"
              name="model"
              aria-describedby="model_help"
              placeholder="Model i.e:IM20-18"
            />
            <div class="invalid-feedback">Please provide a Model Number</div>
          </div>

          <div class="form-group">
            <label for="qty">Quantity *</label>
            <input
              :class="{
                'is-invalid': $v.form.qty.$invalid && submit,
                'is-valid': !$v.form.qty.$invalid && submit
              }"
              type="text"
              v-model="form.qty"
              class="form-control"
              id="qty"
              name="qty"
              aria-describedby="qty_help"
              placeholder="Quantity i.e:99"
            />
            <div class="invalid-feedback" v-if="!$v.form.qty.required">
              Please provide a Quantity
            </div>
            <div class="invalid-feedback" v-if="!$v.form.qty.numeric">
              Only numbers allowed
            </div>
          </div>

          <div v-if="attributes">
            <div class="form-group">
              <label for="name">Name *</label>
              <input
                :class="{
                  'is-invalid': $v.form.productName.$invalid && submit,
                  'is-valid': !$v.form.productName.$invalid && submit
                }"
                type="text"
                v-model="form.productName"
                class="form-control"
                id="name"
                name="name"
                aria-describedby="model_help"
                placeholder="Name i.e:Noopept"
              />
              <div class="invalid-feedback">Please provide a name</div>
            </div>

            <div class="form-group">
              <label for="ingredients">Ingredients *</label>
              <textarea
                rows="7"
                cols="50"
                :class="{
                  'is-invalid': $v.form.ingredients.$invalid && submit,
                  'is-valid': !$v.form.ingredients.$invalid && submit
                }"
                v-model="form.ingredients"
                class="form-control"
                id="ingredients"
                name="ingredients"
                aria-describedby="ingredients_help"
                placeholder="Ingredients i.e: pramiracetam, microcrystalline cellulose"
              ></textarea>
              <div class="invalid-feedback">Please provide ingredients</div>
            </div>

            <div class="form-group">
              <label for="new_ingredients">New Ingredients</label>
              <treeselect
                :options="ingredients"
                id="new_ingredients"
                label="name"
                v-model="form.new_ingredients"
                multiple
                placeholder="Select your ingredients..."
              />
            </div>

            <div class="form-group">
              <label for="stockable">stockable *</label>
              <select
                :class="{
                  'is-invalid': $v.form.stockable.$invalid && submit,
                  'is-valid': !$v.form.stockable.$invalid && submit
                }"
                v-model="form.stockable"
                class="form-control"
                id="stockable"
                name="stockable"
              >
                <option value="yes">yes</option>
                <option value="no">no</option>
              </select>
            </div>

            <div class="form-group">
              <label for="supplier_problem">supplier problem *</label>
              <select
                :class="{
                  'is-invalid': $v.form.supplier_problem.$invalid && submit,
                  'is-valid': !$v.form.supplier_problem.$invalid && submit
                }"
                v-model="form.supplier_problem"
                class="form-control"
                id="supplier_problem"
                name="supplier_problem"
              >
                <option value="yes">yes</option>
                <option value="no">no</option>
              </select>
            </div>

            <div class="form-group">
              <label for="weight">Weight (in gm)</label>
              <input
                :class="{
                  'is-invalid': $v.form.weight.$invalid && submit,
                  'is-valid': !$v.form.weight.$invalid && submit
                }"
                type="text"
                v-model="form.weight"
                class="form-control"
                id="weight"
                name="weight"
                placeholder="weight in gm"
              />
              <div class="invalid-feedback">Only integers are allowed</div>
            </div>

            <div class="form-group">
              <label for="cost">Cost</label>
              <input
                :class="{
                  'is-invalid': $v.form.cost.$invalid && submit,
                  'is-valid': !$v.form.cost.$invalid && submit
                }"
                type="text"
                v-model="form.cost"
                class="form-control"
                id="cost"
                name="cost"
                placeholder="cost i.e: 2.5"
              />
              <div class="invalid-feedback">Only numbers are allowed</div>
            </div>
          </div>

          <div class="d-flex flex-column align-items-end">
            <button
              style="width:150px;"
              class="btn btn-success mb-2"
              type="button"
              @click="stock('add')"
            >
              Add
            </button>
            <button
              style="width:150px;"
              class="btn btn-danger mb-2"
              type="button"
              @click="stock('reduce')"
            >
              Reduce
            </button>
          </div>
          <br />
          <br />
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, numeric, integer, decimal } from "vuelidate/lib/validators";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: "opencart-stock-add",
  components: { Treeselect },
  data() {
    return {
      form: {
        model: "",
        qty: "",
        productName: "",
        ingredients: "",
        stockable: "yes",
        supplier_problem: "no",
        weight: null,
        cost: null,
          normalizer(node) {
              return {
                  id: node.name,
                  label: node.name,
              };
          },
        new_ingredients: [],
      },
      submit: false,
      attributes: false,
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Stock", to: { name: "stock" } },
        { text: "Add New Item", active: true }
      ],
      ingredients: []
    };
  },
  mounted() {
      this.$refs.model.focus();
      this.getIngredients();
  },
  validations() {
    if (!this.attributes) {
      return {
        form: {
          model: {
            required
          },
          qty: {
            required,
            numeric
          }
        }
      };
    } else {
      return {
        form: {
          model: {
            required
          },
          qty: {
            required,
            numeric
          },
          productName: {
            required
          },
          ingredients: {
            required
          },
          stockable: {
            required
          },
          supplier_problem: {
            required
          },
          weight: {
            integer
          },
          cost: {
            decimal
          },
          new_ingredients: {
            required
          },
        }
      };
    }
  },
  methods: {
    trimExpiryDate() {
      const model = this.form.model;
      var matches = model.match(/-[0-9]{6}/);
      if (matches) {
        this.form.model = model.split(matches[0])[0];
      }
    },
    stock(action) {
      this.submit = true;
      if (!this.$v.$invalid) {
        //show loader
        let loader = this.$loading.show();
        let formData = {
          model: this.form.model,
          action: action,
          qty: this.form.qty,
          name: this.form.productName,
          ingredients: this.form.ingredients,
          stockable: this.form.stockable,
          supplier_problem: this.form.supplier_problem,
          weight: this.form.weight,
          cost: this.form.cost,
          new_ingredients: this.form.new_ingredients
        };

        this.$http.post(this.APIURL + this.BRAND + "/stock", formData).then(
          response => {
            if (response.data.status == "new" && action == "add") {
              this.attributes = true;
              this.$swal(
                "New Product Detected!",
                "This Model doesn't exist in stock, if you want to add a new product please fill in the below details:!",
                "info"
              );
              this.submit = false;
              loader.hide();
            } else if (response.data.status == "failed" && action == "reduce") {
              this.$swal("Error!", response.data.error, "warning");
              this.submit = false;
              loader.hide();
            } else {
              this.$swal({
                title: "Success!",
                showConfirmButton: false,
                timer: 1000,
                html:
                  "Operation completed successfully, taking you back to product list.",
                type: "success",
                onClose: () => {
                  loader.hide();
                  this.$router.push({ name: "stock" });
                }
              });
            }
          },
          error => {
            console.log(error);
          }
        );
      }
    },
    getIngredients() {
      let loader = this.$loading.show();
      this.$http
      .get(
        this.APIURL + this.BRAND + "/ingredients"
      )
      .then(
        response => {
          this.ingredients = response.data.ingredients.map(item => ( { id: item.ingredient_id, label: item.name } ));
          loader.hide();
        },
        error => {
          console.log(error);
        }
      );
    },
  }
};
</script>
